import { FC } from 'react';
import { ConfirmationDialog, ConfirmationDialogProps } from '..';

type Props = {
  warnings: Array<string | undefined>;
} & Omit<ConfirmationDialogProps, 'contentText' | 'variant'>;

export const ConfirmationDialogWithWarnings: FC<Props> = ({
  warnings,
  ...confirmationDialogProps
}) => {
  const warningText = warnings.filter((warning) => warning !== undefined).join('\n\n');

  return (
    <ConfirmationDialog
      {...confirmationDialogProps}
      contentText={warningText}
      variant={'warning'}
    />
  );
};
